import { render, staticRenderFns } from "./passwordVerification.vue?vue&type=template&id=6179cd77"
import script from "./passwordVerification.vue?vue&type=script&lang=js"
export * from "./passwordVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./passwordVerification.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports